export const checkIsTaxNumberCorrect: (value: string | undefined) => boolean = (value: string | undefined): boolean => {
  if (value?.length === 10) {
    const weights: number[] = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    const sum: number = weights.reduce(
      (acc: number, currentWeight: number, currentWeightIndex: number): number => {
        return acc + (currentWeight * Number(value[currentWeightIndex]));
      },
      0
    );
    return (sum % 11) === Number(value[9]);
  }

  return false;
};
